<rdo-overlay [enabled]="loading"></rdo-overlay>
<ng-container *featureFlag="'flagSavedViews'">
  <rdo-saved-views
    [gridName]="gridName"
    [pageName]="translateService.instant('main.tabs.equipment.rental_assets.title')"
    />
</ng-container>
<div id="rdo-grid" class="position-relative" [attr.data-max-days-in-status]="txAttributes().maxDaysInStatus">
  @if (selectedProductTypeService.isProductSelected && totalCount > 0) {
    <rdo-grid-table-ng
      #rentalAssetsGrid
      [name]="gridName"
      [gridConfig]="gridConfig()"
      [pagedData]="data"
      [sorting]="sorting"
      [(paging)]="paging"
      (pageOnChange)="changePage($event)"
      (lazyLoadOnChange)="changeLazyLoad($event)"
      [totalCount]="totalCount"
      [frozenWidth]="frozenWidth"
      [showColumnSelector]="true"
      [scrollScale]="'smallScale'"
      (downloadExcelClick)="exportExcel($event)"
      [alwaysShowPager]="false"
      />
  }
</div>
@if (!selectedProductTypeService.isProductSelected || totalCount === 0) {
  <div class="no-data-available">
    {{'main.tabs.equipment.product_types.no_data_available' | translate}}
  </div>
}
